<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('vehicles.vehicles'), name: 'company_vehicles' }, { text: $t('vehicles.addVehicle') }]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <BaseData :templateMode="'add'" :value="vehicle" @submit="createVehicle" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseData from '@/views/companies/vehicles/BaseData'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import vehiclesApi from '@/api/vehicles'

export default {
  name: 'NewCompanyVehicle',
  inject: ['companyUser'],
  data() {
    return {
      vehicle: {},
    }
  },
  components: {
    BaseData,
    BreadCrumbs,
    CompanyNav,
    SectionHeader,
  },
  methods: {
    createVehicle: async function (vehicle) {
      const createdVehicle = await vehiclesApi.create({ company_uuid: this.companyUser.company_uuid, ...vehicle })

      if (createdVehicle) {
        await this.$router.push('/company/vehicles')
      }
    },
  },
}
</script>
